import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '@solara/i18n';
import { ToastProvider } from '@solara/ui-shared';
import { PeppolGatewayProvider } from '@solara/peppol-tickstar/react';
import { SolaraApiProvider } from '@solara/api-client';
import { AuthProvider } from './auth/AuthContext';
import { SessionProvider } from './auth/SessionContext';
import App from './App';
import './styles/app.css';

// Claim a private localStorage slot so we don't share the JWT with the admin
// console (both apps run on the same hostname in dev — different ports — and
// would otherwise collide on the default token key).
(window as unknown as { __SOLARA_TOKEN_KEY__?: string }).__SOLARA_TOKEN_KEY__ =
  'solara.customer.token';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <I18nProvider>
      <ToastProvider>
        <SolaraApiProvider>
          <SessionProvider>
            <AuthProvider>
              <PeppolGatewayProvider region="EU">
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </PeppolGatewayProvider>
            </AuthProvider>
          </SessionProvider>
        </SolaraApiProvider>
      </ToastProvider>
    </I18nProvider>
  </StrictMode>,
);
